<span matBadge="{{mensagensNaoLidas() > 99 ? '99+' : mensagensNaoLidas()}}" matBadgePosition="above after"
  matBadgeHidden="{{mensagensNaoLidas() === 0}}"
  matBadgeColor="warn">
  @if (!imagem?.conteudo) {
    <img class="avatar h-40" src="assets/images/avatars/User.png"
      >
  }
  @if (!!imagem?.conteudo) {
    <img class="avatar h-40" [src]="imagem.conteudo|safeResourceUrl"
      >
  }
</span>

